import React, { forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from '@weareconceptstudio/core';
import { useInput } from '../../form/hooks/useInput';
import BaseInput from '../BaseInput';
const TextArea = forwardRef(({ uppercase = true, ...props }, ref) => {
    useImperativeHandle(ref, () => ({ childType: 'textarea' }));
    const { translate } = useTranslation();
    const { name, placeholder, rows = 5, onChange, onFocus, onBlur, onKeyDown, onKeyUp, disabled, className, autoComplete, } = props;
    const input = name ? useInput({ name, onChange, onBlur }) : null;
    const field = input?.field || {
        onChange: onChange,
        onBlur: onBlur,
    };
    //! On Uppercase
    const inputFirstLatterUppercase = uppercase
        ? (e) => {
            let inputValue = e.target.value.trimStart();
            if (e.target.value.length > 0) {
                e.target.value = inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
            }
        }
        : null;
    return (React.createElement(BaseInput, { ...props },
        React.createElement("textarea", { ...field, rows: rows, onFocus: onFocus, onKeyUp: onKeyUp, disabled: disabled, className: className, onKeyDown: onKeyDown, autoComplete: autoComplete, onInput: inputFirstLatterUppercase, placeholder: translate(placeholder) })));
});
if (process.env.NODE_ENV !== 'production') {
    TextArea.displayName = 'TextArea';
}
export default TextArea;
//# sourceMappingURL=index.js.map